import React, { Component, Fragment } from "react";
import { Route, HashRouter } from "react-router-dom";
import ZipcodeForm from "./ZipcodeForm";
import TestZipcodeForm from "./TestZipcodeForm";
import UnavailableForm from "./UnavailableForm";
import Confirmation from "./Confirmation";
import { Helmet } from "react-helmet";

class Main extends Component {
  render() {
    return (
      <Fragment>
        <Helmet>
          <meta
            http-equiv="Content-Security-Policy"
            content="upgrade-insecure-requests"
          />
          <title>Tested</title>
        </Helmet>
        <div>
          <div className="content">
            <HashRouter>
              <div>
                <Route exact path="/" component={ZipcodeForm} />
                <Route path="/listings/:channel" component={ZipcodeForm} />
                <Route path="/testsearch" component={TestZipcodeForm} />
                <Route path="/unavailable" component={UnavailableForm} />
                <Route
                  path="/submission-confirmation"
                  component={Confirmation}
                />
              </div>
            </HashRouter>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default Main;



// WEBPACK FOOTER //
// ./src/components/Main.js